// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__2oT7E","ScrollX":"Scroll_ScrollX__3oCLj","ScrollY":"Scroll_ScrollY__22qKq"};